export default __webpack_public_path__ + "static/media/ajah-terminal.55a0e5f3.png";